/// <reference path="../typings.d.ts" />
import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from './title';
import { OneRosterService } from './oneroster.service';
import { Alert } from './alert';
import { Registration } from './registration';
import { User } from './user';
import { validateToken } from './account.service';
import { RegistrationFind } from './registration_find';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { controlErrors } from './app.validators';
import { trimReturnKey } from './strings';
import { RegistrationRequest } from './registration_request';
import { SchoolAccount } from './school_account';
import { AccountAssociation } from './account_association';
import { Organization } from './organization';
import { SchoolMapView } from './school_map_view';
import { DropdownOption } from './dropdown_option';
import { isDateSet } from './date_helper';
import { Observable } from 'rxjs';
import { AccountAssociationRequest } from './account_association_request';
import { FindAccountAssociation } from './account_association_find';
import { FindOrganization } from './find_organization';

@Component({
	selector: 'school-mapping',
	styles: [`
        .mt2 {
            margin-top: 15px;
        }
    `],
	template: `
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>
            <div class="col-lg-8 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Identakid School</th>
                                <th>OneRoster School</th>
                                <th>Sync Students</th>
                                <th>Sync Student Contacts</th>
                                <th>Changed At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of schoolMapView; let i = index" style="height: 55px;">
                                <td style="width:18%;">{{ row.iakSchoolName }}</td>
                                <td style="width:20%;">
                                    <div *ngIf="!isEditMode(i) && isRowMapped(row.oneRosterSchoolId)">
                                        {{ orgName(row.oneRosterSchoolId) }}
                                    </div>
                                    <select *ngIf="isEditMode(i)" [(ngModel)]="currentRow.oneRosterSchoolId" class="form-control" title="Organization">
                                        <option *ngFor="let org of orgsDropdown" [value]="org.id">{{org.title}}</option>
                                    </select>
                                </td>
                                <td style="width:12%;">
                                    <div *ngIf="!isEditMode(i) && isRowMapped(row.oneRosterSchoolId)">
                                        {{ row.syncStudents ? 'On' : 'Off' }}
                                    </div>
                                    <app-toggle *ngIf="isEditMode(i)" [(toggle)]="currentRow.syncStudents"></app-toggle>
                                </td>
                                <td style="width:15%;">
                                    <div *ngIf="!isEditMode(i) && isRowMapped(row.oneRosterSchoolId)">
                                        {{ row.syncStudentContacts ? 'On' : 'Off' }}
                                    </div>
                                    <app-toggle style="text-align:center;" *ngIf="isEditMode(i)" [(toggle)]="currentRow.syncStudentContacts"></app-toggle>
                                </td>
                                <td style="width:15%;">
                                    <div *ngIf="isRowMapped(row.oneRosterSchoolId)">
                                        {{ isDateSet(row.updatedAt) ? (row.updatedAt | date: 'MM/dd/y HH:mm') : ''}}
                                    </div>
                                </td>
                                <td style="width:20%;">
                                    <span *ngIf="!isEditMode(i)" title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row, i)">Edit</span>

                                    <div *ngIf="isEditMode(i)">
                                        <span title="Save" class="btn-link" style="cursor: pointer;" (click)="save(row, i)">Save</span>
                                        <span> | </span>
                                        <span title="Cancel" class="btn-link" style="cursor: pointer;" (click)="cancel()">Cancel</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row mt2" [hidden]="msg.msg == ''">
                    <alert [alert]="msg"></alert>
                </div>
            </div>
        </div>
    `
})

export class SchoolMappingComponent implements OnInit {
	msg: Alert;
	msgHead: Alert;
	acctNumber: string;
	hasAccess: boolean;
	maxPageSize: number;
	idParam: string;
	form: FormGroup;
	data: AccountAssociation[];
	schools: SchoolAccount[];
	saveCount: number;
	organizations: Organization[];
	schoolMapView: SchoolMapView[];
	orgsDropdown: DropdownOption[];
	currentRow: SchoolMapView;
	originalRow: SchoolMapView;
	editModeForMap: number;

	constructor(private router: Router, private orvc: OneRosterService, private title: AppTitle, private activatedRoute: ActivatedRoute, fb: FormBuilder) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		title.setTitles({
			title: 'School Mapping',
			dashboard: 'School Mapping'
		});
		this.saveCount = 1;

		this.schools = [];
		this.data = [];
		this.schoolMapView = [];
		this.orgsDropdown = [];
		this.orgsDropdown.push({
			id: '0',
			title: 'None',
		});
		this.currentRow = new SchoolMapView();
	}

	getMode(): string {
		let mode = this.activatedRoute.snapshot.data['mode'];
		if (!mode && this.router.url.indexOf('/sftp/') > -1) {
			return 'sftp';
		}
		return mode || 'registrations';
	}

	ngOnInit() {
		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
		this.idParam = this.activatedRoute.snapshot.params['id'];

		let root = this.getMode();

		this.title.setBreadcrumbs([
			{ title: root.charAt(0).toUpperCase() + root.slice(1) + ' ', link: `/settings/${this.acctNumber}/${root}` },
			{ title: this.idParam + ' ', link: `` },
			{ title: 'School Mapping', link: `` }
		]);

		if (this.acctNumber != null) {
			this.orvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.orvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				})
		}

		let forg = new FindOrganization();
		forg.registrationId = parseInt(this.idParam);
		this.orvc.organizationFindApi(this.acctNumber, forg)
			.subscribe((rows: Organization[]) => {
				this.msg.close();
				this.organizations = rows;

				// populate orgs dropdown
				if (rows.length > 0) {
					for (let org of this.organizations) {
						this.orgsDropdown.push({
							id: org.id.toString(),
							title: org.name,
						})
					}
				}
			}, err => {
				console.log(err);
				if (this.orvc.isErrUnauthorized(err)) {
					this.hasAccess = false;
					this.msg.error(this.orvc.getUserErrorDefault(err));
				} else if (!this.orvc.isErrNotFound(err)) {
					this.msg.error(this.orvc.getUserErrorDefault(err));
				}
			});

		this.loadData();
	}

	isEditMode(idx: number) {
		if (this.editModeForMap === idx) {
			return true;
		}
		return false;
	}

	isRowMapped(orid: number) {
		return orid != 0;
	}

	loadData() {
		this.schoolMapView = [];
		this.orvc.districtAccountAssociationFindApi(this.acctNumber)
			.subscribe((rows: SchoolAccount[]) => {
				this.msg.close();
				this.schools = rows;

				// render district schools
				for (let sch of this.schools) {
					if (sch.enabled) {
						this.schoolMapView.push({
							id: 0,
							schoolAcctNumber: sch.acctNumber,
							iakSchoolName: sch.organizationName,
							oneRosterSchoolId: 0,
							syncStudents: true,
							syncStudentContacts: true,
							updatedAt: new Date(1, 1, 1),
						});
					}
				}

				let root = this.getMode();
				let findReq = new FindAccountAssociation();
				findReq.registrationId = parseInt(this.idParam);
				this.orvc.accountAssociationFindApi(this.acctNumber, findReq)
					.subscribe((rows: AccountAssociation[]) => {
						this.msg.close();
						this.data = rows;

						// render current mapping
						for (let accs of this.data) {
							for (let smv of this.schoolMapView) {
								if (accs.acctNumber == smv.schoolAcctNumber) {
									smv.id = accs.id;
									smv.schoolAcctNumber = accs.acctNumber;
									smv.iakSchoolName = smv.iakSchoolName;
									smv.oneRosterSchoolId = accs.organizationId;
									smv.syncStudents = accs.syncStudents;
									smv.syncStudentContacts = accs.syncStudentContacts;
									smv.updatedAt = accs.updatedAt;
								}
							}
						}
					}, err => {
						console.log(err);
						if (this.orvc.isErrUnauthorized(err)) {
							this.hasAccess = false;
							this.msg.error(this.orvc.getUserErrorDefault(err));
						} else if (!this.orvc.isErrNotFound(err)) {
							this.msg.error(this.orvc.getUserErrorDefault(err));
						}
					});

			}, err => {
				console.log(err);
				if (this.orvc.isErrNotFound(err)) {
					this.msg.warning(this.orvc.getUserError(err));
				} else {
					if (this.orvc.isErrUnauthorized(err)) {
						this.hasAccess = false;
						this.msg.error(this.orvc.getUserErrorDefault(err));
					} else {
						this.msg.error(this.orvc.getUserErrorDefault(err));
					}
				}
			});
	}

	orgName(orgId: number): string {
		for (let org of this.organizations) {
			if (org.id == orgId) {
				return org.name;
			}
		}
		return '';
	}

	edit(row: SchoolMapView, idx: number) {
		this.originalRow = new SchoolMapView();
		if (row.oneRosterSchoolId != 0) {
			this.originalRow.id = row.id;
			this.originalRow.schoolAcctNumber = row.schoolAcctNumber;
			this.originalRow.iakSchoolName = row.iakSchoolName;
			this.originalRow.oneRosterSchoolId = row.oneRosterSchoolId;
			this.originalRow.syncStudents = row.syncStudents;
			this.originalRow.syncStudentContacts = row.syncStudentContacts;
			this.originalRow.updatedAt = row.updatedAt;
		}
		this.currentRow = row;
		this.editModeForMap = idx;
	}

	cancel() {
		this.revertChanges();
		this.editModeForMap = -1;
	}

	revertChanges() {
		if (this.originalRow.id != 0) {
			this.currentRow.id = this.originalRow.id;
			this.currentRow.schoolAcctNumber = this.originalRow.schoolAcctNumber;
			this.currentRow.oneRosterSchoolId = this.originalRow.oneRosterSchoolId;
			this.currentRow.syncStudents = this.originalRow.syncStudents;
			this.currentRow.syncStudentContacts = this.originalRow.syncStudentContacts;
			this.currentRow.updatedAt = this.originalRow.updatedAt;
		}
	}

	viewToRequest(r: SchoolMapView): AccountAssociationRequest {
		let ret = new AccountAssociationRequest();
		ret.registrationId = parseInt(this.idParam);
		ret.acctNumber = r.schoolAcctNumber;
		ret.organizationId = parseInt(r.oneRosterSchoolId.toString());
		ret.syncStudents = r.syncStudents;
		ret.syncStudentContacts = r.syncStudentContacts;
		return ret;
	}

	save(row: SchoolMapView, idx: number) {
		this.currentRow = row;

		// handle delete
		if (this.currentRow.oneRosterSchoolId == 0) {
			if (this.originalRow.oneRosterSchoolId != 0) {
				console.log('deleting accountassoc with id', this.currentRow.id);

				this.orvc.accountAssociationRemoveApi(this.acctNumber, this.currentRow.id)
					.subscribe(res => {
						let saveMessage = this.orvc.getDefaultSaveMessage();
						if (this.saveCount > 1) {
							saveMessage += ` (${this.saveCount})`
						}
						this.saveCount++;
						this.msg.success(saveMessage);

						// remove accountassociation from mapping view
						setTimeout(() => {
							this.schoolMapView[idx].id = 0;
							this.schoolMapView[idx].oneRosterSchoolId = 0;
							this.schoolMapView[idx].syncStudents = true;
							this.schoolMapView[idx].syncStudentContacts = true;
							this.schoolMapView[idx].updatedAt = new Date(1, 1, 1);
						}, 300);

						this.currentRow = new SchoolMapView();
						this.originalRow = new SchoolMapView();
						this.editModeForMap = -1;
						return;
					}, err => {
						console.log(err);
						let e = this.orvc.getUserErrorDefault(err);
						this.msg.error(e);
					});
			}
			this.cancel();
			return;
		}

		// handle update
		if (this.originalRow.oneRosterSchoolId != 0 && (this.currentRow.oneRosterSchoolId != this.originalRow.oneRosterSchoolId || this.currentRow.syncStudents != this.originalRow.syncStudents || this.currentRow.syncStudentContacts != this.originalRow.syncStudentContacts)) {
			console.log('Update Account Association Request', this.viewToRequest(this.currentRow));
			console.log('accs id', this.currentRow.id);
			if (this.currentRow.id != 0) {
				console.log('update')
				this.orvc.accountAssociationUpdateApi(this.acctNumber, this.currentRow.id, this.viewToRequest(this.currentRow))
					.subscribe(res => {
						let saveMessage = this.orvc.getDefaultSaveMessage();
						if (this.saveCount > 1) {
							saveMessage += ` (${this.saveCount})`
						}
						this.saveCount++;
						this.msg.success(saveMessage);

						// update ui
						this.schoolMapView[idx].id = res.id;
						this.schoolMapView[idx].oneRosterSchoolId = this.currentRow.oneRosterSchoolId;
						this.schoolMapView[idx].syncStudents = this.currentRow.syncStudents;
						this.schoolMapView[idx].syncStudentContacts = this.currentRow.syncStudentContacts;
						this.schoolMapView[idx].updatedAt = this.currentRow.updatedAt;

						this.editModeForMap = -1;
						this.currentRow = new SchoolMapView();
						this.originalRow = new SchoolMapView();
						return;
					}, err => {
						console.log(err);
						this.cancel();
						let e = this.orvc.getUserErrorDefault(err);
						this.msg.error(e);
					});
			}
		} else if (this.originalRow.oneRosterSchoolId == 0) {
			this.orvc.accountAssociationAddApi(this.acctNumber, this.viewToRequest(this.currentRow))
				.subscribe(res => {
					let saveMessage = this.orvc.getDefaultSaveMessage();
					if (this.saveCount > 1) {
						saveMessage += ` (${this.saveCount})`
					}
					this.saveCount++;
					this.msg.success(saveMessage);
					// update ui
					this.schoolMapView[idx].id = res.id;
					this.schoolMapView[idx].oneRosterSchoolId = this.currentRow.oneRosterSchoolId;
					this.schoolMapView[idx].syncStudents = this.currentRow.syncStudents;
					this.schoolMapView[idx].syncStudentContacts = this.currentRow.syncStudentContacts;
					this.schoolMapView[idx].updatedAt = this.currentRow.updatedAt;

					this.editModeForMap = -1;
					this.currentRow = new SchoolMapView();
					this.originalRow = new SchoolMapView();
				}, err => {
					console.log(err);
					let e = this.orvc.getUserErrorDefault(err);
					this.msg.error(e);
				});
		}
		this.editModeForMap = -1;
	}

	refresh() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.loadData();
		this.msg.close();
	}

	goBack() {
		let root = this.getMode();
		this.router.navigate([`/settings/${this.acctNumber}/${root}`]);
		return;
	}

	isDateSet(d: Date): boolean {
		if (d && typeof (d) === "object" && d.getFullYear() > 1901) {
			return true;
		}
		return false;
	}
}
